import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { useLecturerCode } from 'hooks';
import { selectBoxFilterOption } from 'utils/form-utils';

export interface LecturerSelectBox {
  codeValue?: any;
  boxSize?: string;
  onChangeSelect?: (value: any | number) => void;
}

const LecturerCode = ({
  codeValue,
  boxSize = '250px',
  onChangeSelect
}: LecturerSelectBox): React.ReactElement => {
    
  /* ======================================================
  * States
  * ====================================================== */
  const [options, setOptions] = useState<any[]>([]);


  /* ======================================================
  * hooks
  * ====================================================== */
  const { lecturerCodeList } = useLecturerCode();  

  /* ======================================================
   * effects
   * ====================================================== */

  useEffect(() => {
    const opts : any[] = [];
    //opts.push({value: 'A', label: '전체'})

    if (lecturerCodeList) {
      lecturerCodeList.forEach((item) => {
        opts.push({value: String(item.value), label: item.label})  
      })
    }

    setOptions(opts);
    
  }, [lecturerCodeList]);

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <Select 
      style={{width:boxSize}} 
      value={codeValue}
      placeholder={'강사'}
      onChange={onChangeSelect}
      virtual={false}
      showSearch={true} 
      options={options}       
      optionFilterProp="label" 
      mode="multiple"    
      allowClear={true}
      filterOption={selectBoxFilterOption}
    /> 
  );
};

export default LecturerCode;
